export default __webpack_public_path__ + "static/media/money-back@2x.50d06af5.png";